import React from 'react';

function PixelMouse() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 128 128">
      <path
        fill="#9AFF00"
        fillRule="evenodd"
        d="M47.998 4.004V0h4v8.004h-4v-4zm32 7.998H56.002v4H83.998v-4h-4zm-4 8h8v4h-16v4h-4v-4h4v-4h8zm-12 8V44h-4v-4H4v-4h56v-8h4zm-7.997 16h-4.004v3.999h-3.998v4h4v-4H60.001v-3.999h-4zm-12.003 7.999v8h-4v43.998h4v8.003h4v3.999H55.999v4h16v-4h8v-3.999h3.999v-8.003h4V60h-4V52.001h-4v8h4V103.998h-4v8.003h-8v4H56.001v-4h-8.003v-8.003h-4V60h4V52.002h-4zm75.999-16.002h-52v4.004h55.999V124H3.999V40.002H0V124.001h3.999V128H123.996v-3.999H128V40.002h-4.004V36h-3.999zM87.998 20.001h-4v-4h4v4zm-35.999-8h4.004v-4h-4.004v4zm24 40h4v-4h-4v-3.999h-8v4h8V52zm-8 8v16.001h-7.998V60H68zm-8 16.003h-3.998V60H60v-4h8v4h3.999V76.004h-4v3.998h-8v-3.998zM64 84h-4v4h8v-4h-4zm-16.002 0h8.004v4h-8.004v-4zm28.001 0h-4v4h8v-4h-4z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default PixelMouse;
